export const routeAlias = {
    home: '',
    dashboard: 'dashboard',
    //login: 'login',
    budgets: {
        home: 'budgets'
    },
    activities: {
        home: 'activities',
        structuresprogrammatiques: {
            home: 'structuresprogrammatiques',
            add: 'add',
            edit: 'edit',
        },
        activity: {
            home: "activity",
            add: "add",
            edit: "edit",
            regroupement_activity: {
                home: "regroupement_activity",
                add: "add",
                edit: "edit",
            }
        },
    },
    marches: {
        home: "marches",
        expression_besoin: {
            home: "expression_besoin",
            add: "add",
            edit: "edit",
            regroupement_expression_besoin: {
                home: "regroupement_expression_besoin",
                add: "add",
                edit: "edit"
            },
        },
        marches: {
            home: "marches",
            add: "add",
            edit: "edit"
        }
    },

    rapports: {
        home: "rapports",
        codir: "codir",
        rapport_mensuel: "mensuel",
        rapport_annuel: "annuel",
        rapport_trimestriel: "trimestriel"
    },
    parameters: {
        home: 'parameters',
        activity: {
            home: 'activity',
            add: 'add',
            edit: 'edit',
            type_activite: {          // ← était typeactivite
                home: 'typeactivities',
                add: 'add',
                edit: 'edit',
            },
            type_intervention: {      // ← était typeintervention
                home: 'typeintervention',
                add: 'add',
                edit: 'edit',
            },
            structures_programmatiques: {      // ← était structuresprogrammatiques
                home: 'structuresprogrammatiques',
                add: 'add',
                edit: 'edit',
            },
            ligne_budgetaire: {       // ← était lignebudgetaire
                home: 'lignebudgetaire',
                add: 'add',
                edit: 'edit',
            },
            structure: {              // ← était structures
                home: 'structures',
                add: 'add',
                edit: 'edit',
            },
            horizons: {
                home: 'horizons',
                add: 'horizons/add',
                edit: 'horizons/edit',
            }
        },
        marches: {
            home: "marches",
            add: "add",
            edit: "edit",
            financements: {
                home: "financements",
                add: "add",
                edit: "edit"
            },
            mode_passation_marches: {
                home: "mode_passation_marches",
                add: "add",
                edit: "edit"
            },
            mode_passation: {
                home: "mode_passation",
                add: "add",
                edit: "edit"
            },
            type_mode_passation: {
                home: "type_mode_passation",
                add: "add",
                edit: "edit"
            }
        },
        comptabilites: {
            home: "comptabilites",
            add: "add",
            edit: "edit",
            compte: {
                home: "compte",
                add: "add",
                edit: "edit",
            },
            typecompte: {
                home: "typecomptes",
                add: "add",
                edit: "edit",
            },
        },
        poste: {
            home: 'postes',
            add: 'add',
            edit: 'edit',
        },
        theme: {
            home: 'theme'
        }
    },
    administration: {
        home: 'administrations',
        agent: {
            home: 'agents',
            add: 'add',
            edit: 'edit',
        },
        utilisateur: {
            home: 'utilisateurs',
            add: 'add',
            edit: 'edit',
        },
        synchronisation: { 
            home: 'synchronisation' 
        },
    },
    setting: {
        home: 'setting',
        infoSysteme: {
            home: 'info-systeme', // session 7 : page à créer
        },
        themeColor: {
            home: 'theme-color', // session 7 : page à créer
        },
    },
    register: 'register',
    custom_pass: 'custom_password',
    setPasswordConfirm: 'setpasswordconfirm',
    forgetpassword: 'forget-password',
    resetpassword: 'reset-password',
    theme: 'theme',
};